import {
  GET_FIBSD_LIST_IN_PROGRESS,
  GET_FIBSD_LIST_SUCCESS,
  GET_FIBSD_LIST_FAIL,
  GET_FIBSD_IN_PROGRESS,
  GET_FIBSD_SUCCESS,
  GET_FIBSD_FAIL,
} from "../constants";
import { LOGOUT } from "../../authentication/constants";

const initialState = {
  list: [],
  inProgress: false,
  error: false,
  details: undefined,
};

/**
 * FIBSD reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function fibsd(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_FIBSD_LIST_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        error: false,
      };

    case GET_FIBSD_LIST_SUCCESS:
      return {
        ...state,
        list: payload.list,
        inProgress: false,
      };

    case GET_FIBSD_LIST_FAIL:
      return {
        ...state,
        list: null,
        inProgress: false,
        error: true,
      };

    case GET_FIBSD_IN_PROGRESS:
      return {
        ...state,
        details: undefined,
      };

    case GET_FIBSD_SUCCESS:
      return {
        ...state,
        details: payload.details,
      };

    case GET_FIBSD_FAIL:
      return {
        ...state,
        details: null,
      };

    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
